import { useCallback, useSyncExternalStore } from 'react';

/**
 * "Show salaries" preference (FR-SAL-8, DESIGN_SYSTEM §4 RevealToggle): masked by default,
 * remembered for the browser session only, and shared by every toggle on the page.
 */
export const REVEAL_STORAGE_KEY = 'thrivehrm-reveal-salaries';

const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return sessionStorage.getItem(REVEAL_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function write(revealed: boolean): void {
  try {
    if (revealed) sessionStorage.setItem(REVEAL_STORAGE_KEY, '1');
    else sessionStorage.removeItem(REVEAL_STORAGE_KEY);
  } catch {
    // Storage unavailable (private mode): the toggle still works for this page view.
  }
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useSalaryReveal(): [boolean, (revealed: boolean) => void] {
  const revealed = useSyncExternalStore(subscribe, read, () => false);
  const set = useCallback((next: boolean) => {
    write(next);
  }, []);
  return [revealed, set];
}
